
import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  getGoodsInfo,
  GoodsInfoDto,
  editGoodsSubmit,
  getCompanyList,
  CompanyListDto
} from '@/api/commodity'
import {
  CustomerListDto,
  deleteMerchants,
  LevelListDto,
  getMerchantsLevelList,
  getMerchantsList
} from '@/api/customerManage'
import { customerPriceDto } from '@/api/goods'
import { confirm } from '@/utils/decorator'
import { Getter } from 'vuex-class'
import { formatterMoney, printFn } from '@/utils/util'
import { Form } from 'vant'
// @ts-ignore
import { isEmpty } from 'lodash'

@Component
export default class coomdsPrices extends Vue {
  @Getter companyId!: string
  formatterMoney = formatterMoney

  $refs!: {
    creatCompany: Form & HTMLElement;
  }

  goodsInfo: GoodsInfoDto | Record<string, any> = {}
  companyList: CompanyListDto | Record<string, any> = {}
  customerList: CustomerListDto[] | Record<string, any> = {}
  levelList: LevelListDto[] = []
  showGroupPicker: boolean[] = []
  showLevelPicker = false
  visible = false
  marketPrice = 0
  isUseCusPrice = 0
  cusPriceList: customerPriceDto[] = []
  type = ''
  labelWidth = 100

  // @Watch('isUseCusPrice', { immediate: true })
  // changeIsUseCusPrice () {
  //   if (!this.isUseCusPrice) this.cusPriceList = []
  //   else this.cusPriceList = [this.initCusPriceList()]
  // }

  get $isDetail () {
    return this.type === 'detail'
  }

  created () {
    this.getCustomerList()
    this.getLevelList()
  }

  showModal (res: {
    data: customerPriceDto[];
    marketPrice: number;
    isUseCusPrice: number;
    type: string;
  }) {
    this.marketPrice = res.marketPrice
    this.isUseCusPrice = res.isUseCusPrice
    this.cusPriceList = res.data
    this.type = res.type
    if (this.isUseCusPrice && !this.cusPriceList.length) {
      // this.cusPriceList = [this.initCusPriceList()];
      this.cusPriceList = [{
        customerId: '',
        levelName: '',
        orderPrice: this.marketPrice,
        minimum: 1,
        maximum: 9999
      }]
    }
    if (this.$route.name === 'CommodsDetail') {
      this.$eventBus.$emit('currentPage', 7)
    }
    console.log(323, this.cusPriceList)
    this.$nextTick(() => {
      this.visible = true
    })
  }

  handleBack () {
    this.$eventBus.$emit('currentPage', 5)
    this.visible = false
  }

  handleHomeBack () {
    if (this.$isDetail) {
      this.$goHomeBack()
      return false
    }
    this.$confirmDialog.show({
      okText: '确认',
      cancelText: '取消',
      tips: '现在退出则不会保存已修改内容，是否确认退出?',
      onOk: () => {
        this.$goHomeBack()
      },
    })
  }

  validatEmptyOrderPrice () {
    return new Promise((resolve) => {
      let emptyOrderPrice = this.cusPriceList.some((priceForm) => {
        return (
          Number(priceForm.minimum) > Number(priceForm.maximum) &&
          priceForm.maximum
        )
      })
      if (emptyOrderPrice) {
        this.$toast('起订量不能大于限订量')
      } else {
        resolve(true)
      }
    })
  }

  handleSave () {
    this.$refs.creatCompany.validate().then(() => {
      this.validatEmptyOrderPrice().then((res) => {
        this.$emit('on-save', {
          isUseCusPrice: this.isUseCusPrice,
          data: this.cusPriceList
        })
        this.handleBack()
      })
    })
  }

  handleChangeIsUseCusPrice () {
    if (!this.isUseCusPrice) {
      this.isUseCusPrice = 1
      this.cusPriceList = [this.initCusPriceList()]
    } else {
      this.closeUseCusPrice()
    }
  }

  @confirm('提示', '关闭客户定价将清除已设置的客户定价信息，是否确认关闭？')
  closeUseCusPrice () {
    this.isUseCusPrice = 0
    this.cusPriceList = []
  }

  /**
   * 初始化按客户定价数据
   */
  initCusPriceList () {
    return {
      customerId: '',
      levelName: '',
      orderPrice: this.marketPrice,
      minimum: 1,
      maximum: null
    }
  }

  addCustomer () {
    this.cusPriceList.push(this.initCusPriceList())
    this.$nextTick(() => {
      this.$refs.creatCompany.$el.scrollTop =
        this.$refs.creatCompany.$el.scrollHeight
    })
  }

  deletePrice (index: number) {
    this.cusPriceList.splice(index, 1)
  }

  //获取客户列表
  getCustomerList () {
    getMerchantsList({isPage: false, companyId: this.companyId}).then(
      (res) => {
        this.customerList = res.data || []
      }
    )
  }

  /**
   * 获取客户级别列表
   */
  getLevelList () {
    getMerchantsLevelList().then((res) => {
      console.log('res', res)

      this.levelList = res.data.levelList || []
      // this.levelList.forEach((item, index: number) => {
      //       const orderPrice = printFn(
      //           (Number(this.marketPrice || 0) * Number(item.buyDiscount || 0)) / 100
      //       )
      //       this.$set(this.levelList![index], 'orderPrice', orderPrice)
      //   })
    })
  }

  edatil () {
    (this.$refs.creatCompany as any).validate().then(() => {
      editGoodsSubmit(this.goodsInfo).then(() => {
        this.$notify({
          type: 'success',
          message: `保存成功`
        })
      })
    })
  }

  delData (id: string) {
    this.$confirmDialog.show({
      okText: '确认',
      cancelText: '取消',
      tips: '确认删除吗？',
      onOk: () => {
        return this.delFunc(id)
      }
    })
  }

  delFunc (id: string) {
    const params = {
      autoId: id
    }
    editGoodsSubmit(params)
      .then((res) => {
        this.$notify({
          type: 'success',
          message: '删除成功'
        })
      })
      .catch(() => {})
  }

  handleMaximumBlur (data: customerPriceDto) {
    if (Number(data.maximum) === 0 && !isEmpty(data.maximum)) {
      data.maximum = 1
    }
    if (data.maximum > this.$defaultSettings.maxNumber(8)) {
      data.maximum = this.$defaultSettings.maxNumber(8)
    }
  }

  /**
   * 过滤已选择的客户
   */
  filterCustomer () {
    // const selectedCustomers = this.cusPriceList!.map(item => item.customerId)
    // return selectedCustomers.includes(customer.merchantsId)
    this.customerList.forEach((item) => {
      const selectedCustomers = this.cusPriceList!.map(
        (item) => item.customerId
      )
      this.$set(item, 'disabled', selectedCustomers.includes(item.merchantsId))
    })
  }

  groupConfirm (value: CustomerListDto, index: number) {
    const selectedCustomers = this.cusPriceList!.map((item) => item.customerId)
    // 如果当前项已被选择
    if (selectedCustomers.includes(value.merchantsId)) return false
    this.cusPriceList[index].customerId = value.merchantsId
    this.cusPriceList[index].customerName = value.merchantsName
    this.cusPriceList[index].levelName = value.levelName
    // 处理每个客商折扣不一样，订货价不一样问题
    this.levelList.forEach(item => {
      if (item.levelName === this.cusPriceList[index].levelName) {
        this.cusPriceList[index].orderPrice = printFn(
          (Number(this.marketPrice || 0) * Number(item.buyDiscount || 0)) / 100
        )
      }
    })
    this.filterCustomer()
    this.showGroupPicker[index] = false
  }

  levelConfirm (value: LevelListDto) {
    this.goodsInfo.customerLevelId = value.levelId
    this.goodsInfo.levelName = value.levelName
    this.showLevelPicker = false
  }
}
